import { createSlice } from '@reduxjs/toolkit'
import { updateObject } from './utility'

const initialState = {
  showNoInternetModal: false,
}

const slice = createSlice({
  name: 'network',
  initialState,
  reducers: {
    showNoInternetModal: (state) => updateObject(state, { showNoInternetModal: true }),
    closeNoInternetModal: (state) => updateObject(state, { showNoInternetModal: false }),
  },
})

export const { showNoInternetModal, closeNoInternetModal } = slice.actions

export default slice
